import { render, staticRenderFns } from "./addField.vue?vue&type=template&id=62cd5067&scoped=true&"
import script from "./addField.vue?vue&type=script&lang=js&"
export * from "./addField.vue?vue&type=script&lang=js&"
import style0 from "./addField.vue?vue&type=style&index=0&id=62cd5067&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd5067",
  null
  
)

export default component.exports